import { render, staticRenderFns } from "./VisitorsChat.vue?vue&type=template&id=74e24d9e"
import script from "./VisitorsChat.vue?vue&type=script&lang=js"
export * from "./VisitorsChat.vue?vue&type=script&lang=js"
import style0 from "./VisitorsChat.vue?vue&type=style&index=0&id=74e24d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports